import dayjs from "dayjs";
import React from "react";
import Slider, { Settings } from "react-slick";
import { Booking } from "../../../../types/bookings";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { formatCurrency } from "../../../libs/utils";

const settings: Settings = {
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
};

const ordinal = (n) => {
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const renderAmount = (amount: number) => <span className="amount">{`${formatCurrency(amount)} / `}</span>;

type RentPerYearProps = {
  booking: Booking;
};
export const RentPerYear = (props: RentPerYearProps) => {
  const { booking } = props;
  const { bookingTerms, leaseTerms, paymentPlan, propertyDetails } = booking;
  const { numberOfRenewalTerms, durationType, contractRent, renewalAmount, annualBaseRent } = bookingTerms ?? {};
  const { leaseStartDate, leaseEndDate } = leaseTerms ?? {};

  const isCommercialUsage = Boolean(propertyDetails?.usagesType.toLowerCase() === "commercial");
  const isMonthly = numberOfRenewalTerms !== 12 && Boolean(contractRent);
  const rentValue = isMonthly ? contractRent : renewalAmount || annualBaseRent;

  const start = dayjs(leaseStartDate);
  const end = dayjs(leaseEndDate);
  const isMultiYear = end.diff(start, "year", true) >= 1;

  if (!rentValue) return null;

  const renderExtensionRent = () => (
    <p className="text-right">
      {renderAmount(contractRent!)}
      {numberOfRenewalTerms && durationType && (
        <span>
          for {numberOfRenewalTerms} {durationType}
        </span>
      )}
    </p>
  );

  const renderAnnualRent = () => {
    if (isCommercialUsage && isMultiYear && paymentPlan?.length)
      return (
        <div className="text-right" style={{ width: 280, margin: "0 auto" }}>
          <Slider {...settings}>
            {paymentPlan?.map(({ annualRent, noOfYear }) => (
              <p key={noOfYear} style={{ display: "grid", placeItems: "center" }}>
                {renderAmount(annualRent)}
                <span>{`${ordinal(noOfYear)} year`}</span>
              </p>
            ))}
          </Slider>
        </div>
      );

    return (
      <p className="text-right">
        {renderAmount(renewalAmount || annualBaseRent!)}
        <span>Year</span>
      </p>
    );
  };

  return <>{contractRent ? renderExtensionRent() : annualBaseRent ? renderAnnualRent() : null}</>;
};
